module.exports = __webpack_public_path__ + "static/media/box.1b54c9a1.svg";